module.exports = __webpack_public_path__ + "img/towels.52d7062b.png";